export enum TipoNeto
{
NetoConceptosFinancieros = 0,
NetoCombustibles = 1,
NetoLubricantes = 2,
NetoMercaderia = 3,
NetoCigarrillos = 4,
NetoNoGravado = 5
}
